<template>
  <div>
    <img src="~common/image/bind-ok.png" alt="" class="icon">
    <div class="line">你已绑定手机成功！</div>
    <div class="line">{{phone}}</div>
    <!-- <router-link class="rebind" to="/personal/bindphone">更换绑定手机</router-link> -->
  </div>
</template>

<script>
import {RES_OK} from '@/api/config'
import {isBind} from '@/api/user-center'
export default {
  data() {
    return {
      phone: ''
    }
  },
  created() {
    isBind().then(({data}) => {
      if (data.code === RES_OK) {
        this.phone = data.data
      }
    })
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .icon
    display block
    width size(282)
    margin size(162) auto size(84)
  .line
    font-size size(32)
    color $color-theme
    line-height 1.5
    text-align center
  .rebind
    position fixed
    bottom size(80)
    color $color-theme
    border 1px solid $color-theme
    line-height size(72)
    border-radius size(36)
    text-align center
    padding 0 size(20)
    min-width size(214)
    font-size size(28)
    left 50%
    margin-left size(-(214 / 2))
</style>


// WEBPACK FOOTER //
// src/components/personal/bindphone/success.vue